import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import PatType from "../enums/pat-type";
import PassedByPositionPref from "./position-pref/passed-by-position-pref";
import PassType from "../enums/pass-type";

export default class PatPass extends Fragment {
    constructor(passedBy, passType) {
        super();

        this.patType = PatType.PASS.code;
        this.passedBy = passedBy;
        this.passType = passType;

        this.requiredData = [
            {
                name: "passedBy",
                type: FragmentDataType.Player,
                displayName: "Passed By",
                title: (team) => `Passed By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player
                     from ${team.teamName} or enter the roster number`,
                isEditable: true,
                positionPref: (play) =>
                    new PassedByPositionPref(play, this).resolve()
            },
            {
                name: "passType",
                type: FragmentDataType.PassType,
                displayName: "Passed to",
                title: "Passed to",
                subtitle: () => "Select direction of pass",
                isEditable: true,
                optional: true
            }
        ];
    }

    getFragmentTeamId() {
        return this.passedBy?.teamId;
    }

    getPlayers() {
        return [this.passedBy];
    }

    updateSummaryContext(summaryContext) {
        summaryContext.playerInPossession = this.passedBy;
    }

    summarize(summaryContext, stringifier) {
        let message = `${stringifier.firstInitial(this.passedBy)} ${
            summaryContext?.gameConfig?.scoring?.runPAT
        }-point pass attempt`;

        if (this.passType && this.passType.code !== PassType.SKIP.code) {
            message += ` ${this.passType.name.toLowerCase()}`;
        }

        return new FragmentSummary(message);
    }

    toJSON() {
        return {
            ...super.toJSON(),
            passedBy: playerReducer(this.passedBy)
        };
    }

    getScoringPoints(gameConfig) {
        return gameConfig.scoring.runPAT;
    }

    excludeRequiredData(rd, gameConfig) {
        if (rd.name === "passType") {
            return !gameConfig.general.passType;
        }

        return false;
    }
}
